import * as types from '../mutation_types'
import Vue from 'vue'
const state = {
  hasApply: false,
  listLen: -1,
  applyList: [],
  currFriendMessageList: [],
  currFriendReadInfo: null,
  list: {}
}
const getters = {
  recentFriendList: (state) => {
    // return Object.values(state)
    // 用于检测长度变化
    if (state.listLen > -1) {
      return Object.values(state.list)
    }
  },
  sortedFriendList: (state) => {
    if (state.listLen > -1) {
      return Object.values(state.list)
    }
  },
  applyInfo: (state) => {
    return state.applyList
  }
}

const actions = {
}

const mutations = {
  [types.CLEAR_FRIEND](state) {
    state.hasApply = false
    state.listLen = -1
    state.applyList.length = 0
    state.currFriendMessageList.length = 0
    Vue.set(state, 'list', {})
  },
  [types.SET_FRIEND_LIST](state, friendObj) {
    // 先清空
    Vue.set(state, 'list', {})

    for (const friendId in friendObj) {
      Vue.set(state.list, friendId, friendObj[friendId])
    }
    state.listLen = Object.keys(state.list).length
  },
  [types.ADD_FRIEND](state, friendInfo) {
    // Vue.set(state.list, friendInfo.id, friendInfo)
    // state.list[friendInfo.id] = friendInfo
    Vue.set(state.list, friendInfo.id, friendInfo)
    state.listLen = Object.keys(state.list).length
  },
  [types.SET_EDIT_MESSAGE](state, { friendId, editMessage }) {
    Vue.set(state.list[friendId], 'editMessage', editMessage)
  },
  [types.SET_LAST_MESSAGE](state, { friendId, lastMessage }) {
    // Object.assign(state.list[friendId].lastMessage, lastMessage)
    Vue.set(state.list[friendId], 'lastMessage', lastMessage)
    // state.list[friendId].lastMessage = lastMessage
    // 判断如果有isFailed，则放入localMessageList
    if (lastMessage.isFailed !== undefined) {
      state.list[friendId].localMessageList.push(lastMessage)
    }
  },
  [types.ACCEPT_MESSAGE](state, { friendId, messageObj }) {
    // 找到消息，更新消息，删除本地消息
    const index = state.list[friendId].localMessageList.indexOf(messageObj)
    if (index > -1) {
      state.list[friendId].localMessageList.splice(index, 1)
      if (state.list[friendId].lastMessage.tempId === messageObj.tempId) {
        // 显式 更新最后一条消息
        state.list[friendId].lastMessage.id = messageObj.id
      }
    }
  },
  [types.REJECT_MESSAGE](state, { friendId, messageObj }) {
    const index = state.list[friendId].localMessageList.indexOf(messageObj)
    if (index > -1) {
      // 显式 更新本地消息
      state.list[friendId].localMessageList[index].isFailed = messageObj.isFailed
      if (state.list[friendId].lastMessage.tempId === messageObj.tempId) {
        // 显式 更新最后一条消息
        state.list[friendId].lastMessage.isFailed = messageObj.isFailed
      }
    }
  },
  [types.SET_MESSAGE_READ](state, { friendId }) {
    state.list[friendId].lastMessage.isNRead = false
  },
  [types.SET_APPLY](state, toState) {
    state.hasApply = toState
  },
  [types.ADD_APPLY](state, friendInfo) {
    state.applyList.push(friendInfo)
  },
  [types.ADD_CURR_FRIEND_MESSAGE](state, messageObj) {
    state.currFriendMessageList.push(messageObj)
  },
  [types.SET_FRIEND_READ_INFO](state, info) {
    Vue.set(state, 'currFriendReadInfo', info)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/friend.js